import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68ac51f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-summary" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = ["aria-label", "onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-area" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filtersMap, (filter, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          ($setup.shouldShowFilter(filter))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["filter-wrapper", { selected: $setup.isSelected(filter[0]) }]),
                type: "button",
                "aria-label": $setup.getFilterLabel(filter[0]),
                onClick: ($event: any) => ($setup.onClickFilter(filter[0]))
              }, [
                _createElementVNode("span", null, _toDisplayString($setup.getFilterValue(filter[0])), 1 /* TEXT */),
                _createCommentVNode(" <InlineSvg\n            v-if=\"isSelected(filter[0])\"\n            :src=\"require('@/assets/icons/x-icon.svg')\"\n            alt=\"삭제\"\n          />\n          <InlineSvg\n            v-else\n            :src=\"require('@/assets/icons/chevron-down.svg')\"\n            alt=\"\"\n          /> ")
              ], 10 /* CLASS, PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _hoisted_4,
    _createElementVNode("button", {
      type: "button",
      class: "icon-btn",
      "aria-label": "필터 열기",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickFilter')))
    }, [
      _createVNode($setup["InlineSvg"], {
        src: 
          require(`@/assets/icons/${
            $setup.hasAppliedFilters
              ? 'filter_slider_applied.svg'
              : 'filter_slider.svg'
          }`)
        ,
        alt: "필터 열기"
      }, null, 8 /* PROPS */, ["src"])
    ])
  ]))
}